<template lang="pug">
.event-item
  .component-title 共检索到
    span {{ total }}
    | 个危机
  .lists
    CaseCollectionList(:lists="list")
    .loading
      a(v-show="!loading && pages.now < pages.sum", @click.prevent="more") 查看更多
      loader(v-show="loading")
</template>

<script>
import client from '../server/server'
import moment from 'moment'
import _ from 'lodash'
import Loader from '../components/Loader'
import CaseCollectionList from '../CaseCollection/CaseCollectionList'
export default {
  name: 'EventItem',
  components: {
    Loader,
    CaseCollectionList
  },
  data () {
    return {
      list: [],
      pages: {
        now: 1,
        sum: 1
      },
      total: '',
      loading: false
    }
  },
  computed: {
    compareIds () {
      return this.$store.getters.compareIds
    }
  },
  created () {
    let keyword = this.$route.params.keyword
    // console.log(keyword)
    if (keyword) {
      this.search()
    }
  },
  watch: {
    compareIds: {
      deep: true,
      handler (val) {
        this.list = this.list.map(d => {
          return Object.assign({}, d, {
            vs: !!val.find(m => m.id === d.id)
          })
        })
      }
    },
    '$route.params' (val) {
      // console.log(val)
      this.pages.now = 1
      this.search()
    }
  },
  methods: {
    search () {
      let params = {
        keyword: this.$route.params.keyword,
        page: this.pages.now,
        size: 6
      }
      if (params.page === 1) {
        this.list = []
      }
      this.loading = true
      client.getSearchEvents(params)
        .then(res => {
          if (res.success) {
            this.total = res.data.total
            this.pages.sum = res.data.pages
            let tmp = res.data.list.map(d => {
              return Object.assign({}, d, {
                startTime: moment(d.startTime).format('YYYY/MM/DD'),
                brands: [d.priBrand].concat(d.secBrands),
                categories: d.priCrisisTags.concat(d.secCrisisTags)
              })
            })
            if (this.pages.now === 1) {
              this.list = [...tmp]
            } else {
              this.list = this.list.concat(tmp)
            }
            this.list = this.list.map(d => {
              return Object.assign({}, d, {
                vs: !!this.compareIds.find(m => m.id === d.id)
              })
            })
            this.loading = false
          }
        })
    },
    more () {
      this.pages.now++
      this.search()
    },
    compareEvent (l) {
      let data = this.compareIds.slice()
      if (l.vs) {
        data = _.reject(data, d => d.id === l.id)
      } else {
        if (data.length > 1) {
          this.$message({
            message: '对比事件添加上限',
            type: 'warning',
            center: true
          })
          return false
        }
        data = data.concat(l)
      }
      this.$store.dispatch('updateCompareIds', data)
    },
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeEventCollect(data)
        .then(res => {
          if (res.success) {
            this.list.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/common";

.event-item {
  background: #fff;
  border-radius: 4px;
  height: calc(100% - 72px);

  .component-title {
    font-size: 16px;
    color: #333;
    margin: 30px 0 20px;

    span {
      color: #f87653;
    }
  }

  .lists {
    height: calc(100% - 10px);
    overflow-y: auto;
    @include scrollBar;

    .loading {
      margin: 10px 0;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }

  .list {
    .type {
      display: inline-block;
      margin: 4px;
      padding: 3px 6px;
      border-radius: 2px;
      background-color: #3989cb;
      color: #fff;
      font-size: 12px;
    }

    .item {
      display: flex;
      min-height: 150px;
      margin: 0 24px;
      padding: 0 0 20px;
      border-bottom: 1px solid #f0f0f0;
      align-items: center;

      .logo {
        min-width: 80px;
        margin: 20px 30px 0 10px;

        img {
          width: 80px;
          height: 80px;
          background-color: #ffffff;
          border: solid 1px #e8ebf1;
          border-radius: 50%;
        }
      }

      .details {
        color: #999;
        font-size: 12px;
        flex: 1;

        .title {
          color: #333;
          font-size: 14px;

          &:hover {
            color: #3989cb;
          }
        }

        .context {
          margin-top: 15px;
        }

        .startTime {
          margin-top: 10px;
        }

        .tags {
          display: flex;
          align-items: center;
          margin-top: 10px;

          .tag {
            margin-right: 10px;
            padding: 3px 6px;

            &.brand {
              background-color: #fef1ed;
              border-radius: 2px;
              border: solid 1px #f87653;
              color: #f87653;
            }

            &.category {
              background-color: #ebf3fa;
              border-radius: 2px;
              border: solid 1px #3989cb;
              color: #3989cb;
            }
          }
        }
      }

      .operation {
        margin: 0 40px 0 100px;
        min-width: 100px;
        color: #666;
        font-size: 12px;
        text-align: center;

        .score {
          font-size: 24px;
          color: #f87653;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .operations {
          margin-top: 30px;

          button {
            width: 26px;
            height: 26px;
            border-radius: 4px;
            border: solid 1px #e8ebf1;
            background: #fff;
            margin: 0 5px;

            &.active {
              border: solid 1px #3989cb;
              background: #3989cb;
              color: #fff;
            }

            i {
              color: #999;
            }

            &.star {
              &.active {
                border: solid 1px #3989cb;
                background: #3989cb;

                .fa-star {
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/EventItem.vue